import { useQuery } from "@tanstack/react-query";
import { getAcademicYear } from "../../api/apiAcademicYears";
import i18next from "i18next";

export function useGetAcademicYear(id) {
    const { isLoading, data: academicYear, error } = useQuery({
        queryKey: ["academicYears", id, i18next.language],
        queryFn: () => getAcademicYear(id),
        enabled: !!id,
        retry: false,
    });

    return { isLoading, error, academicYear };
}
